import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { ModalTransition } from '@atlaskit/modal-dialog';
import { globalSettingsIssuesPrioritySchemesRoute } from '@atlassian/jira-router-routes-admin-pages-priorities-routes';
import type {
	PriorityCurrentModalState,
	Priority,
	PriorityFormAsyncErrors,
} from '../../common/types';
import { DeleteInUseModal } from './delete-in-use-modal';
import { DeletePriorityModal } from './delete-modal';
import { MovePriorityModal } from './move-modal';

type PriorityModalProps = {
	currentModal: PriorityCurrentModalState;
	totalItems: number;
	asyncFormErrors?: PriorityFormAsyncErrors;
	onClose: () => void;
	onDelete: (priority: Priority) => void;
	onSetPosition: (priorityId: string, order: number) => Promise<void>;
};

export const PriorityModalSwitcher = ({
	currentModal,
	totalItems,
	onClose,
	onDelete,
	onSetPosition,
}: PriorityModalProps) => {
	if (currentModal === null) {
		return null;
	}

	return (
		<ModalTransition>
			{/* SET POSITION */}
			{currentModal.modalName === 'MOVE' && (
				<MovePriorityModal
					priority={currentModal.priority}
					total={totalItems}
					onClose={onClose}
					onConfirm={onSetPosition}
				/>
			)}

			{/* DELETE */}
			{currentModal.modalName === 'DELETE' && (
				<DeletePriorityModal
					onClose={onClose}
					priority={currentModal.priority}
					onConfirm={() => onDelete(currentModal.priority)}
				/>
			)}

			{/* DELETE_IN_USE */}
			{currentModal.modalName === 'DELETE_IN_USE' && (
				<DeleteInUseModal
					onClose={onClose}
					priority={currentModal.priority}
					schemesLink={`${globalSettingsIssuesPrioritySchemesRoute.path}?priority.id=${currentModal.priority.id}`}
				/>
			)}
		</ModalTransition>
	);
};
